import React, { useState, useRef, useEffect } from 'react';
import { SelectOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import { message, Tooltip } from 'antd';
import './sidebar.css';
import ItemList from '../Items';
import { useDispatch, useSelector } from 'react-redux';
import { setBackgroundImage, setIsDrawingMode } from '../../Reducers/mileSpaceSlice';
import { updateSpace } from '../../Services/spaceServices';
import { useParams } from 'react-router-dom';
import downArrowIcon from '../../Assets/down-arrow.png';
import uArrowIcon from '../../Assets/up-arrow.png';
import { setIsDocumentChanged } from '../../Reducers/documentInfoSlice';

const Sidebar = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const itemListRef = useRef(null);
    const isDrawingMode = useSelector((state) => state.mileSpace.isDrawingMode);
    const [activeTool, setActiveTool] = useState(isDrawingMode ? 'pen' : 'select');
    const [topCursor, setTopCursor] = useState('not-allowed');
    const [bottomCursor, setBottomCursor] = useState('pointer');
    const isReadOnly = useSelector((state) => state.documentData.isReadOnly);
    const spaceData = useSelector((state)=>state.mileSpace.spaceData);

    const handleIconClick = (key) => {
        setActiveTool(key);
        if (key === 'pen') {
            dispatch(setIsDrawingMode(true));
        } else if (key === 'select') {
            dispatch(setIsDrawingMode(false));
        } else if (key === 'upload') {
            fileInputRef.current.click();
        }
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];

        if (!file) {
            message.error('No file selected.');
            return;
        }

        // Validate file type
        const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
        if (!validTypes.includes(file.type)) {
            message.error('Only image files (JPG, PNG, GIF) are allowed.');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const imageUrl = reader.result;
            dispatch(setBackgroundImage(imageUrl));
            const payload = {
                id,
                updatedData: {
                    ...spaceData,
                    backgroundImage: imageUrl,
                },
            };
            dispatch(updateSpace(payload));
            dispatch(setIsDocumentChanged(true));
            //   message.success('Background image updated successfully!');
        };

        reader.onerror = () => {
            message.error('okkkFailed to read the file.');
        };

        reader.readAsDataURL(file);
    };

    const scrollItemList = (scroll) => {
        if (itemListRef.current) {
            itemListRef.current.scrollBy({
                top: scroll,
                behavior: 'smooth',
            });
        }
    };
    const handleScroll = () => {
        if (itemListRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = itemListRef.current;
            if (scrollTop === 0) {
                setTopCursor('not-allowed');
            } else {
                setTopCursor('pointer');
            }
            if (scrollTop + clientHeight >= scrollHeight - 1) {
                setBottomCursor('not-allowed');
            } else {
                setBottomCursor('pointer');
            }
        }
    };

    useEffect(() => {
        const list = itemListRef.current;
        if (list) {
            list.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (list) {
                list.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <div className="sidebar" style={{ display: isReadOnly ? 'none' : 'flex' }}>
            {/* Hidden file input */}
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageUpload}
                style={{ display: 'none' }}
            />

            <div className="icon-container">
                <Tooltip title="Select" placement="right">
                    <div
                        className={`icon-wrapper ${activeTool === 'select' ? 'selected' : ''}`}
                        onClick={() => handleIconClick('select')}
                    >
                        <SelectOutlined />
                    </div>
                </Tooltip>

                <Tooltip title="Draw" placement="right">
                    <div
                        className={`icon-wrapper ${activeTool === 'pen' ? 'selected' : ''}`}
                        onClick={() => handleIconClick('pen')}
                    >
                        <EditOutlined />
                    </div>
                </Tooltip>

                <Tooltip title="Upload Image" placement="right">
                    <div
                        className='icon-wrapper'
                        onClick={() => handleIconClick('upload')}
                    >
                        <UploadOutlined />
                    </div>
                </Tooltip>
            </div>

            {/* Horizontal Divider */}
            <hr className="divider" />
            <div
                onClick={() => scrollItemList(-50)}
                style={{ cursor: topCursor, marginTop: '-12px', marginBottom: '6px' }}
            >
                <img src={uArrowIcon} width={20} alt="Scroll Up" />
            </div>
            <ItemList ref={itemListRef} />
            <div
                onClick={() => scrollItemList(50)}
                style={{ cursor: bottomCursor, marginTop: '6px' }}
            >
                <img src={downArrowIcon} width={20} alt="Scroll Down" />
            </div>
        </div>
    );
};

export default Sidebar;
